import { useEffect } from "react";
import cache from "../cache";

// This component is designed as a hack to allow us to clear the cache easily in
// places where we aren't fully using React.
const PurgeCacheHelper = () => {
  useEffect(() => cache.purge());
  return null;
};

export default PurgeCacheHelper;
